import { User } from "../core/user";

export function isDefenderInstalled() {
    return (new User()).installed;
}